module.exports = __webpack_public_path__ + "media/src/images/logo-6a4350e85346244a7f68514eb1b4b5fc.png";